import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
        return ajax.get("Procurements/api/DepartmentsQuery/by-paging").then(r => {
          commit("setList", r.data.data);
          return r.data.data;
        });
      },
      departmanList({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Procurements/api/DepartmentsQuery/search-on?name=" + name)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    createDepartman({ commit, dispatch }, model) {
        return ajax.post("Procurements/api/Departments", model).then(() => {
          dispatch("fetch");
        });
      },
    editDepartman({ commit, dispatch }, model) {
        return ajax.put("Procurements/api/Departments", model).then(() => {
          dispatch("fetch");
        });
      },
    deleteDepartman({ commit, dispatch }, model) {
        return ajax.delete("Procurements/api/Departments", { data: { id: model } },).then(() => {
          dispatch("fetch");
        });
      }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
